var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "external-link-icon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.714 0v.857H8.54L3.57 5.824l.605.605L9.143 1.46v2.825H10V0H5.714z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.714 0v.857H8.54L3.57 5.824l.605.605L9.143 1.46v2.825H10V0H5.714z",
    fill: "#333230"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.714 0v-1h-1v1h1zm0 .857h-1v1h1v-1zm2.825 0l.707.707 1.707-1.707H8.539v1zM3.57 5.824l-.707-.707-.707.707.707.708.707-.708zm.605.605l-.708.707.708.707.707-.707-.707-.707zM9.143 1.46h1V-.953L8.436.754l.707.707zm0 2.825h-1v1h1v-1zm.857 0v1h1v-1h-1zM10 0h1v-1h-1v1zM4.714 0v.857h2V0h-2zm1 1.857H8.54v-2H5.714v2zM7.831.15L2.864 5.117l1.414 1.415 4.968-4.968L7.83.15zM2.864 6.532l.604.604 1.415-1.414-.605-.605-1.414 1.415zm2.019.604L9.85 2.169 8.436.754 3.468 5.722l1.415 1.414zm3.26-5.675v2.825h2V1.46h-2zm1 3.825H10v-2h-.857v2zm1.857-1V0H9v4.286h2zM10-1H5.714v2H10v-2z",
    fill: "#333230",
    mask: "url(#external-link-icon_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.768 1.286H1V9h7.714V4.96",
    stroke: "#333230"
  })));
}
export default SvgExternalLinkIcon;